// src/admin/utils/openViewParams.js
//
// Convention for opening a sub-view / workflow from anywhere (onboarding, nav, links).
// Use URL search param ?open=<key>. The page that owns the sub-view reads the param,
// opens the modal/wizard, then clears the param so the URL stays clean.

export const OPEN_VIEW_PARAM = 'open';

/** Values for ?open= on the dashboard (assign-task opens TaskAssignmentWizard). */
export const DASHBOARD_OPEN = {
  ASSIGN_TASK: 'assign-task',
};

/**
 * Build dashboard URL that will open a specific sub-view on load.
 * @param {string} viewKey - One of DASHBOARD_OPEN.*
 * @returns {string} Path + query, e.g. '/admin/dashboard/?open=assign-task'
 */
export function dashboardOpenUrl(viewKey) {
  const base = '/admin/dashboard/';
  if (!viewKey) return base;
  return `${base}?${OPEN_VIEW_PARAM}=${encodeURIComponent(viewKey)}`;
}

/** Values for ?open= on the assets list (redirects to first asset) and asset details (opens TaskReportModal). */
export const ASSETS_OPEN = {
  TASK_REPORT: 'task-report',
};

/**
 * Build assets URL that will open the task-report sub-view (redirect to first asset, then open a task report modal).
 * @param {string} viewKey - One of ASSETS_OPEN.*
 * @returns {string} Path + query, e.g. '/admin/assets?open=task-report'
 */
export function assetsOpenUrl(viewKey) {
  const base = '/admin/assets';
  if (!viewKey) return base;
  return `${base}?${OPEN_VIEW_PARAM}=${encodeURIComponent(viewKey)}`;
}

/** Open a specific task report on an asset details page. */
export const TASK_ID_PARAM = 'task_id';

/** Active tab on asset details when deep-linking to a task. */
export const ASSET_TAB_PARAM = 'tab';

/**
 * Build asset URL that opens TaskReportModal for a task.
 * @param {number|string} assetId
 * @param {number|string} taskId
 * @param {{ tab?: 'history'|'feedback' }} [options]
 */
export function assetTaskUrl(assetId, taskId, { tab } = {}) {
  const params = new URLSearchParams();
  if (taskId != null && taskId !== '') {
    params.set(TASK_ID_PARAM, String(taskId));
  }
  if (tab) {
    params.set(ASSET_TAB_PARAM, tab);
  }
  const qs = params.toString();
  return `/admin/assets/${assetId}${qs ? `?${qs}` : ''}`;
}

